import { array, arrayOf, shape, string, bool } from "prop-types";
import { useEffect, useRef, useState } from "react";

import Menu from "./Menu.jsx";
import Modal from "../Modal/Modal.jsx";
import React from "react";
import cx from "classnames";
import useClickAway from "../../common/useClickAway.js";
import useMatchMedia from "../../common/useMatchMedia.js";
import AnimateHeight from "react-animate-height";

const propTypes = {
  showExploreNav: bool,
  exploreTitle: shape({
    title: string,
    url: string,
    exploreText: string,
  }),
  breadCrumbs: arrayOf(shape({ text: string, href: string })),
  folders: array,
  pageId: string,
};

const SecondaryNavigation = (props) => {
  const { showExploreNav, exploreTitle, breadCrumbs, folders, pageId } = props;

  const [isOpen, setIsOpen] = useState(false);

  const ref = useRef();

  const matchesDesktop = useMatchMedia("(min-width: 1024px)");

  useClickAway({ isOpen, setOpen: setIsOpen, ref });

  useEffect(() => {
    const el = document.querySelector(".js-secondary-navigation-mount");
    isOpen && el.classList.add("is-open");
    !isOpen && el.classList.remove("is-open");
  }, [isOpen]);

  return (
    <section
      className={cx("secondary-navigation", {
        "secondary-navigation--is-open": isOpen,
      })}
    >
      <div
        ref={matchesDesktop ? ref : null}
        className="secondary-navigation__wrapper"
      >
        <div className="secondary-navigation__header">
          <div className="secondary-navigation__left">
            {showExploreNav && (
              <>
                {folders?.length > 0 ? (
                  <button
                    className={cx("secondary-navigation__menu-btn", {
                      "secondary-navigation__menu-btn--open": isOpen,
                    })}
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <div>{exploreTitle.exploreText}</div>
                    <div className="secondary-navigation__chevron"></div>
                  </button>
                ) : (
                  <div>{exploreTitle.exploreText}</div>
                )}
              </>
            )}
          </div>
          <div className="secondary-navigation__right">
            {breadCrumbs.map((item, i, arr) => (
              <React.Fragment key={i}>
                {pageId === item.pageId ? (
                  <span
                    className="secondary-navigation__breadcrumb-link js-truncate-text"
                    data-char-limit="22"
                  >
                    {item.text}
                  </span>
                ) : (
                  <a
                    className="secondary-navigation__breadcrumb-link js-truncate-text"
                    data-char-limit="22"
                    href={item.href}
                  >
                    {item.text}
                  </a>
                )}
                {i === arr.length - 1 ? null : <span> / </span>}
              </React.Fragment>
            ))}
          </div>
          {matchesDesktop ? (
            <AnimateHeight
              className={cx("secondary-navigation__menu", {
                "secondary-navigation__menu--open": isOpen,
              })}
              height={isOpen ? "auto" : 0}
              easing="ease-in-out"
              aria-hidden={false}
            >
              <Menu
                exploreTitle={exploreTitle}
                pageId={pageId}
                folders={folders}
              />
            </AnimateHeight>
          ) : (
            <Modal
              className="secondary-nav__modal"
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              title={exploreTitle.exploreText}
            >
              <Menu
                exploreTitle={exploreTitle}
                pageId={pageId}
                folders={folders}
              />
            </Modal>
          )}
        </div>
      </div>
    </section>
  );
};

SecondaryNavigation.propTypes = propTypes;
export default SecondaryNavigation;
